/* eslint-disable react-hooks/exhaustive-deps */

import { axiosInstance } from '@app-store'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { useEffect, useState } from 'react'

const useCustomFetchAgent = <T,>(
  url: string,
  options?: AxiosRequestConfig,
  extraDeps?: unknown
) => {
  const [data, setData] = useState<T | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<unknown>(null)

  useEffect(() => {
    if (!url) return
    const fetchData = async () => {
      setLoading(true)
      try {
        const res: AxiosResponse<T> = await axiosInstance(url, options)
        setData(res.data)
      } catch (err) {
        setError(err)
      }
      setLoading(false)
    }
    fetchData()
  }, [url, extraDeps]) // Note: passing options here will cause infinite rerenders.

  return { data, loading, error }
}

export default useCustomFetchAgent
